export const formatInterviewLogDateTime = (dateString: string | null | undefined) => {
  if (!dateString) return "N/A";
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return "N/A";
  const datePart = d.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
  const timePart = d.toLocaleTimeString("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
  return `${datePart} at ${timePart}`;
};

/** API may return score as 0–1, 0–10, or 0–100; returns display percent or null. */
export const normalizeInterviewPercent = (
  score: number | null | undefined
): number | null => {
  if (score === null || score === undefined || Number.isNaN(Number(score))) {
    return null;
  }
  const n = Number(score);
  if (n < 10) return Math.round(n * 10);
  return Math.round(n);
};
